/**
 * Role-specific growth ladder, built only from each career's own data:
 * the role itself, then its own Stretch careers (the roles experience here
 * leads into), then an own-practice step where the data says
 * entrepreneurship potential is real. Display only — no scoring.
 */
export type LadderStep = { name: string; note: string; isRole: boolean };

export function buildGrowthLadder(input: {
  name: string;
  level?: string | null;
  stretch?: string[];
  entrepreneurship?: string | null;
}): LadderStep[] {
  const steps: LadderStep[] = [
    {
      name: input.name,
      note: input.level && !/varies/i.test(input.level)
        ? `Where you start — usually at ${input.level.toLowerCase()} level.`
        : "Where you start: learn the work and build your first real results.",
      isRole: true,
    },
  ];
  const seen = new Set([input.name.trim().toLowerCase()]);
  for (const s of input.stretch ?? []) {
    const k = s.trim().toLowerCase();
    if (!k || seen.has(k)) continue;
    seen.add(k);
    steps.push({
      name: s.trim(),
      note: steps.length === 1
        ? "The next step up, once you've built real experience here."
        : "A bigger step: more scope, more responsibility.",
      isRole: true,
    });
    if (steps.length >= 4) break;
  }
  const ent = (input.entrepreneurship ?? "").toLowerCase();
  if (ent.startsWith("high") || ent.startsWith("medium")) {
    steps.push({
      name: "Run your own practice",
      note: "Many people in this work go on to start their own business or practice.",
      isRole: false,
    });
  }
  return steps;
}
